import { useEffect, useState } from 'react';
import { LayoutProps } from './VideoViewsLayout';
import useVideoLayout from '$Utilities/hooks/useVideoLayout';
import { VideoAsset } from '$Utilities/models/videoViews';
import { Box, Grid } from 'MaterialUIComponents';
import VideoBox from './VideoBox';
import { React } from 'Imports';

const GridView = (props: LayoutProps) => {
    const [transitionEffect, setTransitionEffect] = useState(false);
    const videoHeight = 360;

    const { mainVideos: leftColumn, secondaryVideos: rightColumn } = useVideoLayout(props.videoAssets, props.primaryChannelNumber, 'Grid');

    useEffect(() => {
        setTransitionEffect(true);
    }, [props.videoAssets]);

    const renderColumn = (videos: VideoAsset[]) => (
        <Grid item xs>
            <Box>
                {videos?.map((video, idx) => (
                    <div key={idx} style={{ marginBottom: '16px' }}>
                        <VideoBox
                            key={idx}
                            video={video}
                            transitionEffect={transitionEffect}
                            height={videoHeight}
                            maxHeight={videoHeight}
                            onVideoDownloaded={props.onVideoDownloaded}
                        />
                    </div>
                ))}
            </Box>
        </Grid>
    );

    return (
        <Grid container gap={'16px'} flexWrap="nowrap">
            {renderColumn(leftColumn)}
            {renderColumn(rightColumn)}
        </Grid>
    );
};

export default GridView;
